/**
 * @desc 合并报关
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.MergeCustomsDeclarationRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/mergeCustomsDeclaration`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
